var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "tree-list" },
    _vm._l(_vm.treeList, function (item, index) {
      return _c("div", { key: index, staticClass: "tree-list-item" }, [
        _c(
          "span",
          { staticClass: "tree-list-item-label" },
          [
            _c(
              "yxt-tooltip",
              { attrs: { placement: "top-start", "max-width": 500 } },
              [
                _c(
                  "span",
                  { attrs: { slot: "content" }, slot: "content" },
                  [_c("yxtbiz-dept-name", { attrs: { name: item.name } })],
                  1
                ),
                _c("yxtbiz-dept-name", { attrs: { name: item.name } }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "span",
          {
            staticClass: "tree-list-item-tool",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            item.h
              ? _c(
                  "span",
                  {
                    staticClass: "tree-list-item-tool-next",
                    on: {
                      click: function ($event) {
                        return _vm.handleNext(item)
                      },
                    },
                  },
                  [_vm._v("下级")]
                )
              : _vm._e(),
            _vm.functions && _vm.funs.length > 0
              ? _c(
                  "yxt-dropdown",
                  {
                    attrs: {
                      "custom-elm": "",
                      dropdownToBody: _vm.dropdownToBody,
                    },
                    on: { "visible-change": _vm.visibleChange },
                  },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "color-gray-6 hover-primary-6 yxtbiz-base-tree-slot-icon",
                      },
                      [
                        _c("yxt-svg", {
                          attrs: {
                            width: "16px",
                            height: "16px",
                            "icon-class": "set",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "yxt-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      _vm._l(_vm.funs, function (funsItem, index) {
                        return _c(
                          "yxt-dropdown-item",
                          {
                            key: index,
                            attrs: { disabled: funsItem.disabled || false },
                            nativeOn: {
                              click: function ($event) {
                                return _vm.dropdownItemHandle(funsItem)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _c("span", [_vm._v(_vm._s(funsItem.label))]),
                            ]),
                          ]
                        )
                      }),
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }